import React from 'react';
import { withRouter } from 'react-router-dom';
import { StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import posthog from 'posthog-js';
import { translateCourse } from 'helpers/translations';
import { useSelector } from 'react-redux';
import CourseKind from 'enums/courseKind';

export const LMS = ({ data }) => {
    const { user } = useSelector(state => state.user);

    const [course, setCourse] = React.useState({ course_Id: '', lms: '' });

    React.useEffect(() => {
        const temp = { ...data } || {};
        setCourse(translateCourse(user.language_Code, temp));
    }, [data]);

    const st = (s, x) => SystemText(`Search/Results/Training/${s}`, x);
    const accelerate = course.lms === 'accelerate';
    const challenger = course.lms === 'challenger';
    const learn2 = course.lms === 'learn2';

    const onClick = () => {
        if (accelerate || learn2) {
            posthog.capture('launched-learning', {
                course: course.name,
                course_status: course.status,
                course_id: course.id,
            });

            window.location.href = course.url;
        } else if (challenger) {
            posthog.capture('launched-challenger-learning', { course: course.name });
            window.open(course.url);
        } else {
            window.open(course.url);
        }
    };

    const labelClass = x => {
        switch (x.toLowerCase()) {
            case 'completed':
            case 'course_completed':
                return 'success';
            case 'in_progress':
            case 'course_started':
                return 'warning';
            default:
                return 'grey';
        }
    };

    // For challenger statuses
    if (course.status === 'course_completed') course.status = 'completed';
    if (course.status === 'course_started') course.status = 'in_progress';
    if (course.status === 'license_access') course.status = 'not_started';

    const icon = data.kind === CourseKind.RolePlayAi ? 'fa-sparkles' : 'fa-book-open';
    const title = data.kind === CourseKind.RolePlayAi ? st('TitleAiRoleplay') : st('Title');

    return (
        <div data-testid="lms-search" className="search-result box" onClick={onClick}>
            <div className="image-holder hidden-xs">
                <img src={`/dist/img/${course.lms.toLowerCase()}-icon.png`} alt={course.lms} loading="lazy" />
            </div>
            <div>
                <label className="label label-primary">
                    <i className={`mr10 fa ${icon}`} />
                    {title}
                </label>
                <h2>{course.name}</h2>
                {(course.description || course.summary) && <p>{course.description || course.summary}</p>}
                {course.information && (
                    <div className="text-sm mt5" title={st('Duration')}>
                        <i className="fa fa-clock mr5" />
                        {course.information}
                    </div>
                )}
                {course.duration > 0 && (
                    <div className="text-sm mt5" title={st('Duration')}>
                        <i className="fa fa-clock mr5" />
                        {StringHelpers.displayMinutes(course.duration / 60)}
                    </div>
                )}
                {course.status && (
                    <div className="text-sm mt5">
                        <label className={`label uppercase label-${labelClass(course.status)}`}>
                            {SystemText(`Search/Results/Training/Status/${course.status}`)}
                        </label>
                    </div>
                )}
                {/* {data.tags?.length > 0 && (
                    <div>
                        {data.tags.map(tag => (
                            <label
                                key={`tag-${data.id}-${tag.replace(' ', '')}`}
                                className="label label-default mr5 mt5"
                                style={{ display: 'inline-block' }}
                            >
                                {tag}
                            </label>
                        ))}
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default withRouter(LMS);
